import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import { HOMEPAGE_SPECIAL_EVENT_PATH } from "utils/constants/paths";

const SpecialEventView = Loadable(React.lazy(() => import("./View")));

export const SpecialEventRoute: IRouteItem = {
  path: HOMEPAGE_SPECIAL_EVENT_PATH,
  element: React.createElement(SpecialEventView),
  name: "Homepage Special Event",
};
